import { Icons } from "@/components/ui/icons";

/** A weather icon by its `Icons` name (`inferConditionIcon`), else a cloud. */
export function DayIcon({
  name,
  className,
}: {
  name: string;
  className?: string;
}) {
  const candidate = Icons[name as keyof typeof Icons] as unknown;
  const Icon =
    typeof candidate === "function" ||
    (typeof candidate === "object" && candidate !== null)
      ? (candidate as typeof Icons.Cloud)
      : Icons.Cloud;
  return <Icon className={className} aria-hidden="true" />;
}
